module.exports = __webpack_public_path__ + "img/img_48.dbf82987.png";